// apps/web/src/pages/admin/shared/StatusTag.tsx — Phase 5 plan 05-04 (D-23).
//
// Maps the 5-value `RESERVATION_STATUS` enum to the wireframe tag
// classes. The visual contract is owned by this component so the
// pages never scatter `className` strings.
//
// D-23:
//   - `BESTAETIGT` / `ANGEFRAGT` / `STORNIERT` → tag-neutral
//   - `ANGEKOMMEN`                              → tag-accent
//   - `NO_SHOW`                                 → tag-outline

import { useTranslation } from "react-i18next";

export type ReservationStatusValue =
  "BESTAETIGT" | "ANGEFRAGT" | "ANGEKOMMEN" | "NO_SHOW" | "STORNIERT";

const STATUS_TAG_CLASS: Record<ReservationStatusValue, string> = {
  BESTAETIGT: "tag tag-neutral",
  ANGEFRAGT: "tag tag-neutral",
  ANGEKOMMEN: "tag tag-accent",
  NO_SHOW: "tag tag-outline",
  STORNIERT: "tag tag-neutral",
};

const RESERVATION_ROW_CLASS: Record<ReservationStatusValue, string> = {
  BESTAETIGT: "",
  ANGEFRAGT: "",
  ANGEKOMMEN: "",
  NO_SHOW: "",
  STORNIERT: "opacity-50 line-through",
};

export function StatusTag({ status }: { status: ReservationStatusValue }) {
  const { t } = useTranslation();
  return (
    <span
      className={STATUS_TAG_CLASS[status]}
      data-testid={`status-tag-${status}`}
    >
      {t(`status.${status}`)}
    </span>
  );
}

export function reservationRowClass(status: ReservationStatusValue): string {
  return RESERVATION_ROW_CLASS[status];
}
